import React from "react";
import VillaDetails from "./VillaDetails";
import OtherFeaturesSection from "./OtherFeaturesSection";
import PoolInfoSection from "./PoolInfoSection";
import InfoSection from "./InfoSection";
import RulesSection from "./RulesSection";

const AboutSection = ({ villa }) => {
  return (
    <div id="about" className="flex flex-col">
      <div className="rounded-[20px] border border-[#E7EDF4] p-4 lg:mb-20 md:mb-10 mb-5">
        <VillaDetails villa={villa} />
        {villa?.ozellikler && (
          <OtherFeaturesSection features={villa?.ozellikler} />
        )}
        <PoolInfoSection villa={villa} />
        <InfoSection
          sozlesme={villa?.sozlesme?.icerik}
          checkIn={villa?.giris_saat}
          checkOut={villa?.cikis_saat}
        />
        <RulesSection rules={villa?.kurallar} />
      </div>
    </div>
  );
};

export default AboutSection;
